import lang from '../../lib/language';

import DocumentsReviewingPng from '../../assets/img/documentsReviewing.png';

import styles from './DocumentsReviewingNotification.module.scss';

const DocumentsReviewingNotification = () => (
    <div className={styles.gridContainer} id="documentsReviewingNotification">
      <div className={styles.container}>
        <div className={styles.containerImg} />
        <div className={styles.content}>
          <img src={DocumentsReviewingPng} alt="reviewingDocuments" />
          <div className={styles.textContainer}>
            <div className={styles.title}>{lang.reviewingDocuments()}</div>
            <div className={styles.text}>{lang.reviewingDocumentsDescription()}</div>
          </div>
        </div>
      </div>
    </div>
);

export default DocumentsReviewingNotification;
